import { put, select, call } from 'redux-saga/effects';
import { delay } from 'redux-saga';
import { authTokenSelector } from '../../session';
import { apiActionResult } from '../../common';

/**
 * Higher-Order Generator that creates unified 5-second polling workers.
 * Protects connection stability and cleanly isolates business/team scopes.
 */
export const createPollingWorker = ({
  apiAction,
  apiTarget,
  shouldStopPolling,
  onComplete,
  loggerName = 'Poller'
}) => {
  return function* pollingWorker(...args) {
    while (true) {
      try {
        const authToken = yield select(authTokenSelector);

        yield put(apiAction(authToken, ...args));

        const result = yield apiActionResult(apiTarget);

        if (result.success) {
          const payload = result.success.payload || {};

          if (shouldStopPolling(payload)) {
            if (typeof onComplete === 'function') {
              yield call(onComplete, ...args);
            }
            break;
          }
        } else {
          console.warn(
            `[${loggerName}] Request superseded or encountered an error. Re-evaluating...`
          );
        }
      } catch (error) {
        console.error(
          `[${loggerName}] Critical worker thread failure execution context:`,
          error
        );
        break;
      }

      yield call(delay, 5000);
    }
  };
};



// WEBPACK FOOTER //
// ./src/state/modules/task/configurations/pollingUtils.js